"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mlgPremiumOverrideReason = void 0;
exports.mlgPremiumOverrideReason = [
    'ON RESERVE',
    'IND RESER',
    'MLG',
    'MIN GUAR',
    'MUP GUARANTEE',
    'MINIST. GUARANTEE',
];
